const answerStyles: any = {
	xs: { width: '130px', height: '130px' },
	sm: { width: '140px', height: '140px' },
	md: { width: '200px', height: '200px' },
	lg: { width: '230px', height: '230px' },
};

const getAnswerStyles = ({ greaterThanExtraSmall, greaterThanSmall, greaterThanMidl, greaterThanLarge }: any) => {
	let currentScreenSize = 'xs';
	if (greaterThanExtraSmall) {
		currentScreenSize = 'sm';
	}
	if (greaterThanSmall) {
		currentScreenSize = 'md';
	}
	if (greaterThanMidl) {
		currentScreenSize = 'lg';
	}
	if (greaterThanLarge) {
		currentScreenSize = 'lg'; // Use xl if lessThanLarge is true
	}

	return answerStyles[currentScreenSize];
};

const getTextStyles = (isCheckQuestion: boolean, withIcon: boolean) => {
	return {
		width: '100%',
	};
};

export const getStyles = ({ theme, screenSize, isCheckQuestion, withIcon }: any) => {
	return {
		container: {
			display: 'flex',
			justifyContent: 'center',
		},
		button: {
			overflow: 'hidden',
			lineHeight: 0,
			borderRadius: '8px',
			backgroundColor: theme.palette.playbookIconButton.backgroundColor,
			border: '3px solid transparent',
			...getAnswerStyles(screenSize),
		},
		disabledButton: {
			overflow: 'hidden',
			lineHeight: 0,
			borderRadius: '8px',
			backgroundColor: 'rgba(0, 0, 0, 0.12)',
			'.MuiTypography-root': {
				color: 'rgba(0, 0, 0, 0.26)',
			},
			'.MuiBox-root': {
				color: 'rgba(0, 0, 0, 0.26)',
			},
			pointerEvents: 'none',
			border: '3px solid transparent',
			...getAnswerStyles(screenSize),
		},
		selectedButton: {
			overflow: 'hidden',
			lineHeight: 0,
			borderRadius: '8px',
			border: `3px solid ${theme.palette.playbookIconButton.selectedBorderColor}`,
			...getAnswerStyles(screenSize),
		},
		answerText: {
			...getTextStyles(isCheckQuestion, withIcon),
			color: theme.palette.primary.dark,
			whiteSpace: 'pre-line',
		},
		selectedAnswerText: {
			...getTextStyles(isCheckQuestion, withIcon),
			color: theme.palette.primary,
			whiteSpace: 'pre-line',
		},
		icon: {
			transform: 'scale(0.65)',
			[theme.breakpoints.up('xs')]: {
				transform: 'scale(0.65)',
			},
			[theme.breakpoints.up('sm')]: {
				transform: 'scale(0.85)',
			},
			[theme.breakpoints.up('md')]: {
				transform: 'scale(1)',
			},
		},
	};
};
